module.exports = __webpack_public_path__ + "img/login2.9a11f7bf.png";